export function Footer() {
    return (
        <div className={"footer"}>
            <p> contact me : xeno.weij@outlook.be  </p>
        </div>
    );
}